import {useState} from 'react';
import {
  IValidation,
  ValidationText,
} from '../../types/client-management/departmentTypes';

const useValidation = (defaultText: ValidationText, defaultHelper: string) => {
  const [validationState, setValidationState] = useState<IValidation>({
    fieldName: '',
    validationName: '',
    isError: false,
    helperText: defaultHelper,
    validationText: defaultText,
  });

  const setValidationError = (validationName: string) => {
    setValidationState((prevState) => ({
      ...prevState,
      isError: !!validationName,
      validationName: validationName,
    }));
  };

  return {validationState, setValidationError};
};

export default useValidation;
